import { partInfoHelper } from "@/components/mixins";
import CurrencyText from "@/components/Elements/CurrencyText.vue";
import LoadingSpinner        from "@/components/Elements/LoadingSpinner.vue";

export default {
  components: {
    CurrencyText,
    LoadingSpinner
  },
  props: {
    part: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  mixins: [partInfoHelper],
  methods: {},
  created(){
    this.addToCartQuantity = 1 //hardcoded to 1 for now. We may want to add an input for qty in the next iteration
  }
}